export class RULES {
  static readonly USER_NAME_REGEX: RegExp = /^[a-zA-Z\u0400-\u052F]+(?:[-' ][a-zA-Z\u0400-\u052F]+)*$/;
  static readonly USER_NAME_MIN_LENGTH = 2;
  static readonly USER_NAME_MAX_LENGTH = 50;

  static readonly EMAIL_REGEX: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static readonly EMAIL_MIN_LENGTH = 3;
  static readonly EMAIL_MAX_LENGTH = 500;

  static readonly PASSWORD_MIN_LENGTH = 8;
  static readonly PASSWORD_MAX_LENGTH = 50;

  static readonly PHONE_REGEX: RegExp = /^\+[0-9]*$/;
  static readonly PHONE_MIN_LENGTH = 7;
  static readonly PHONE_MAX_LENGTH = 15;

  static readonly COMPANY_NAME_MIN_LENGTH = 2;
  static readonly COMPANY_NAME_MAX_LENGTH = 60;

  static readonly SCIM_CONFIG_NAME_MAX_LENGTH = 30;

  static readonly URL_REGEX: RegExp = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
  static readonly ONLY_DIGITS_REGEX = /^[0-9]*$/;
  static readonly HTTPS_REGEX = /^https:\/\//;

  static readonly TELEGRAM_REGEX = /^@[a-zA-Z0-9_]{5,32}$/;

  static readonly COMPANY_SETTINGS_LABEL_REGEX: RegExp = /^[a-zA-Z\u0400-\u052F0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
  static readonly COMPANY_SETTINGS_LABEL_MAX_LENGTH = 30;
  static readonly COMPANY_SETTINGS_LABEL_POSITION_MAX_LENGTH = 50;
  static readonly COMPANY_LOGO_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.svg'];

  static readonly LONG_TEXT_MAX_LENGTH = 1000;
  static readonly MIDDLE_TEXT_MAX_LENGTH = 500;
  static readonly SHORT_TEXT_MAX_LENGTH = 200;

  static readonly CALENDAR_DAYS_MIN = 1;
  static readonly CALENDAR_DAYS_MAX = 365;

  static readonly IMG_MAX_SIZE_MB = 5;
  static readonly PDF_MAX_SIZE_MB = 50;

  static readonly EMPLOYEE_PFP_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.svg', '.webp'];

  static readonly COMPANY_SSO_NAME_MIN_LENGTH = 2;
  static readonly COMPANY_SSO_NAME_MAX_LENGTH = 50;
}

export class LOCAL_STORAGE_KEYS {
  static readonly SKIP_DASHBOARD = 'skipDashboardOnLogin';
  static readonly ACTIVE_COMPANY_ID = 'companyId';

  static readonly ACCESS_TOKEN = 'accessToken';
  static readonly REFRESH_TOKEN = 'refreshToken';
}

export const OIDC_PROVIDERS = [
  {
    id: 'jumpcloud',
    name: 'JumpCloud',
    logo: './assets/images/jumpcloud-logo.svg',
    issuerUri: 'https://oauth.id.jumpcloud.com/'
  },
  {
    id: 'google-workspace',
    name: 'Google Workspace',
    logo: './assets/images/google-icon.svg',
    issuerUri: 'https://accounts.google.com'
  }
] as const;

